<template>
  <NavBar
    :home-link="homeLink"
    :brand-logo="brandLogo"
    :brand-mobile-logo="brandMobileLogo"
    :brand-name="brandName"
    :small-nav="smallNav"
    :has-nav-b-g-img="hasNavBGImg"
    :color-theme="colorTheme"
  >
    <slot slot="logo" name="logo" />
    <slot v-if="isNotBBC && showTagline" slot="tagline">
      <div class="dividing-line" />
      <span class="nav-bar__tagline">Business connectivity</span>
    </slot>

    <div class="link-wrap">
      <slot name="right">
        <img
          v-if="isWhiteLabel && isNotBBC"
          :src="require(`../assets/logos/${rightLogo}`)"
          alt="Provided by Bionic"
          class="provided-by-image"
        >
        <a v-else-if="showAboutUs && isNotBBC" href="#" class="about-link" @click.prevent="clickAbout">{{
          isMobile ? "About" : "About Us"
        }}</a>
        <div
          v-if="isWhiteLabel || showAboutUs"
          class="dividing-line"
          :class="{'dividing-line--hide': !isNotBBC}"
        />
        <div class="phone-number">
          <PhoneIcon
            :is-circle="isMobile"
            :phone-number="micPhoneNumberFormatted"
            :phone-icon="phoneIcon"
            :color-theme="colorTheme"
          >
            <slot slot="phoneIcon" name="phoneIcon" />
            <slot slot="expandedPhoneIcon" name="expandedPhoneIcon" />
          </PhoneIcon>
          <div v-if="!isMobile" class="phone-number__opening-hours" :class="`phone-number__opening-hours--${colorTheme}`">
            Monday - Friday from 9:00 to 17:30
          </div>
        </div>
      </slot>
    </div>
  </NavBar>
</template>

<script>
import { mapGetters } from 'vuex'
import NavBar from './NavBar'
import Routable from '../mixins/Routable'
import PhoneIcon from '../icons/PhoneIcon'

export default {
  name: 'SmartNavBar',

  components: {
    PhoneIcon,
    NavBar
  },

  mixins: [Routable],

  props: {
    homeLink: {
      type: String,
      default: process.env.VUE_APP_HOME_URL || '/'
    },
    brandLogo: {
      type: String,
      default: 'bionic-logo-light.svg'
    },
    brandMobileLogo: {
      type: String,
      default: 'bionic-logo-light.svg'
    },
    brandName: {
      type: String,
      default: 'Bionic'
    },
    showTagline: {
      type: Boolean,
      default: false
    },
    showAboutUs: {
      type: Boolean,
      default: true
    },
    phoneIcon: {
      type: String,
      default: 'call-light.svg'
    },
    smallNav: {
      type: Boolean,
      default: false
    },
    colorTheme: {
      type: String,
      default: ''
    },
    rightLogo: {
      type: String,
      default: 'provided-by-logo.svg'
    },
    hasNavBGImg: {
      type: Boolean,
      default: false
    },
    hideRightLogo: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapGetters(['isMobile', 'micPhoneNumberFormatted']),
    isWhiteLabel () {
      return this.$brandName !== 'bionic'
    },
    isNotBBC () {
      return this.$brandName !== 'bbc'
    },
    trustpilotHeight () {
      return this.isMobile ? '28px' : '64px'
    },
    trustpilotWidth () {
      return this.isMobile ? '57px' : '110px'
    }
  },

  methods: {
    clickAbout () {
      this.$emit('click:about')
    }
  }
}
</script>

<style lang="scss" scoped>
.phone-number__opening-hours {
  font-size: 10px;
  text-align: right;

  &--purple {
    color: $purple-1;
  }
}

.link-wrap {
  display: flex;
  color: $white;
  height: 100%;
  align-items: center;
  font-size: 16px;
  font-weight: bold;

  @media (max-width: $screen-md) {
    font-weight: 500;
  }
}

.about-link {
  color: $white;
  font-size: 19px;
  line-height: 22px;
  text-decoration: none;

  .light & {
    color: $white;
  }

  @media (max-width: $screen-md) {
    font-size: 16px;
    line-height: 19px;
  }
}

.dividing-line {
  width: 1px;
  background-color: $white;
  height: 38px;
  margin: $spacing-0 $spacing-12;

  &--hide {
    display: none;
  }

  @media (max-width: $screen-md) {
    height: 24px;
  }

  .nav-bar.light & {
    background-color: $white;
  }
}

.provided-by-image {
  height: 32px;
  width: 70px;

  @media (max-width: $screen-sm) {
    height: 28px;
    width: 61px;
  }
}

.logo-wrap {
.nav-bar__tagline,
.dividing-line {
  display: none;

  @media(min-width: 390px) {
    display: inline;
  }
}
}

</style>
